function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M5.985 13.975a3.512 3.512 0 01-4.96 0 3.512 3.512 0 010-4.96L3.78 6.26a3.512 3.512 0 014.96 0 .585.585 0 11-.827.827 2.32 2.32 0 00-3.306 0L1.852 9.842a2.32 2.32 0 000 3.306 2.32 2.32 0 003.306 0l2.617-2.617a.585.585 0 11.827.826l-2.617 2.618zM11.22 8.74a3.512 3.512 0 01-4.96 0 .585.585 0 11.827-.827 2.32 2.32 0 003.306 0l2.755-2.755a2.32 2.32 0 000-3.306 2.32 2.32 0 00-3.306 0L7.224 4.469a.585.585 0 11-.826-.826l2.617-2.618a3.512 3.512 0 014.96 0 3.512 3.512 0 010 4.96L11.22 8.74z",
  fill: "currentColor",
  opacity: 0.5
});

function SvgLink(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgLink;